import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { Button } from './button';
import { Badge } from './badge';
import { cn } from '../../lib/utils';

interface FloatingBulkActionBarProps {
  selectedCount: number;
  onClear: () => void;
  children: React.ReactNode;
}

export function FloatingBulkActionBar({
  selectedCount,
  onClear,
  children,
}: FloatingBulkActionBarProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (selectedCount > 0) {
      setMounted(true);
    }
  }, [selectedCount]);

  if (!mounted && selectedCount === 0) return null;

  return (
    <div
      className={cn(
        "fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex items-center gap-4 px-4 py-3",
        "backdrop-blur-md bg-slate-900/95 shadow-2xl rounded-2xl border border-slate-700/50",
        "transition-all duration-300 ease-in-out origin-bottom",
        selectedCount > 0 ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-8 scale-95 pointer-events-none"
      )}
      onTransitionEnd={() => {
        if (selectedCount === 0) setMounted(false);
      }}
    >
      <div className="flex items-center gap-3">
        <Badge variant="secondary" className="bg-slate-800 text-white hover:bg-slate-700 border-none px-2 py-1">
          {selectedCount} đã chọn
        </Badge>
        
        <div className="h-6 w-px bg-slate-700" />
        
        <div className="flex items-center gap-2">
          {children}
        </div>
        
        <div className="h-6 w-px bg-slate-700" />
        
        <Button
          variant="ghost"
          size="sm"
          onClick={onClear}
          className="text-slate-300 hover:text-white hover:bg-slate-800 h-8 px-2"
          title="Bỏ chọn (Esc)"
        >
          <X className="h-4 w-4 mr-1" />
          Đóng
        </Button>
      </div>
    </div>
  );
}
